import { render, staticRenderFns } from "./ElegiacInformation.vue?vue&type=template&id=b2ca726e&scoped=true"
import script from "./ElegiacInformation.vue?vue&type=script&lang=js"
export * from "./ElegiacInformation.vue?vue&type=script&lang=js"
import style0 from "./ElegiacInformation.vue?vue&type=style&index=0&id=b2ca726e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ca726e",
  null
  
)

export default component.exports